import React, { type ReactNode, useCallback } from "react";
import { FormattedMessage } from "react-intl";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import type { IPopupProps } from "src/shared/hooks/popups/usePopup";

export interface IMessagePopupProps extends IPopupProps<void> {
  header: ReactNode;
  children: ReactNode;
  ok?: ReactNode;
}

export const MessagePopup = ({
  closePopup,
  header,
  children,
  ok = <FormattedMessage id="popups.message.ok" />,
}: IMessagePopupProps) => {
  const handleClosePopup = useCallback(() => {
    closePopup();
  }, [closePopup]);

  return (
    <Modal isOpen toggle={handleClosePopup}>
      <ModalHeader toggle={handleClosePopup}>{header}</ModalHeader>
      {children && <ModalBody>{children}</ModalBody>}
      <ModalFooter>
        <Button type="submit" color="primary" onClick={handleClosePopup}>
          {ok}
        </Button>
      </ModalFooter>
    </Modal>
  );
};
